exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doviz-report-table[data-v-3e682fa5],.doviz-report-table>*[data-v-3e682fa5]{width:100%}", ""]);

// exports
